import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { ModulesDTO } from "../../../../common/types/ModulesDTO";
import { baseQuery } from "../../client/DefaultClient";

export const moduleService = createApi({
  reducerPath: "moduleService",
  baseQuery: fetchBaseQuery(baseQuery),
  tagTypes: ["Modules"],
  endpoints: (builder) => ({
    getModules: builder.query<ModulesDTO, { userId: number }>({
      query: ({ userId }) => `api/modules/${userId}`,
      providesTags: [{ type: "Modules" }],
    }),
  }),
});

export const { useGetModulesQuery } = moduleService;
